export default __webpack_public_path__ + "static/media/frieght.a58cf643.png";